import { SearchIcon } from 'components/icons/search-icon'
import React, { Component } from 'react'
import { Button } from 'reactstrap'
import './_styles.scss'

interface SearchBarProps {
  inputChange?: any
  label?: string
  onSubmit?: any
}

interface SearchBarState {
  searchTerm: string
}

export class SearchBarComponent extends Component<SearchBarProps, SearchBarState> {
  private debounceTimer: NodeJS.Timeout | null = null

  constructor(props) {
    super(props)
    this.state = {
      searchTerm: '',
    }
  }

  public componentWillUnmount() {
    // Clean up timer on unmount
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }
  }

  public render() {
    return (
      <div className="rct-search-bar">
        <div className="input-container">
          <SearchIcon />
          <input
            type="text"
            placeholder="Search for a source..."
            value={this.state.searchTerm}
            onChange={this.handleInputChange}
            onKeyPress={e => this.enterPressed(e)}
          />
        </div>
        <Button className="rct-button search-submit" onClick={this.handleClick}>
          <div className="search-label">{this.props.label || 'Search'}</div>
        </Button>
      </div>
    )
  }

  private handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    this.setState({ searchTerm: value })

    // Clear existing timer
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }

    // Set new timer for debounced search
    this.debounceTimer = setTimeout(() => {
      this.props.onSubmit(value)
    }, 800) // 800ms debounce delay - slower for better UX
  }

  private handleClick = () => {
    // Clear timer and execute search immediately on button click
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }
    this.props.onSubmit(this.state.searchTerm)
    this.setState({ searchTerm: '' })
  }

  private enterPressed = e => {
    const code = e.keyCode || e.which
    if (code === 13) {
      // Clear timer and execute search immediately on Enter
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer)
      }
      this.handleClick()
    }
  }
}
